"use client";

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState } from 'react';

export function ReactQueryProvider({ children }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            // Data is considered fresh for 5 minutes (300,000 ms)
            // This prevents refetching data from Firebase if the user navigates back and forth
            staleTime: 5 * 60 * 1000, 
            // Keep unused data in cache for 30 minutes
            gcTime: 30 * 60 * 1000, 
            refetchOnWindowFocus: false, // Do not refetch when the user switches browser tabs
            retry: 1, // Only retry failed requests once
          },
        },
      })
  );

  return (
    <QueryClientProvider client={queryClient}>
      {children}
    </QueryClientProvider>
  );
}
